import {defineStore} from "pinia";
import _ from "lodash";

export const DISMISSIBLE_IN = 3500; //3.5 seconds

export class Notification{
    constructor(title, options) {
        this.id = String.uniqueID('notification');
        this.title = title;
        this.message = _.get(options, 'message', null);
        this.type = options.type;
        this.filled = true;
        this.dismissible = true;
        this.dismissibleIn = DISMISSIBLE_IN; //3.5 seconds
        this.flag = true;
    }

    static make(title, message, options){
        options.message = message;

        const notification = new Notification(title, options);

        toast().push(notification);

        return notification;
    }

    static info(title, message){
        return Notification.make(title, message, {
            type: 'info',
        });
    }

    static success(title, message){
        return Notification.make(title, message, {
            type: 'success',
        });
    }

    static warning(title, message){
        return Notification.make(title, message, {
            type: 'warning',
        });
    }

    static error(title, message){
        return Notification.make(title, message, {
            type: 'error',
        });
    }
}

export const toast = defineStore('toast', {
    state: () => ({
        notifications: [],
        maxVisible: 1,
    }),

    getters: {
        visibleNotifications() {
            return this.notifications.slice(0, this.maxVisible);
        },
    },

    actions: {
        push(notification) {
            if(!notification.id){
                notification.id = String.uniqueID('notification');
            }

            this.notifications.push(notification);

            return this;
        },

        shift() {
            //this will only work at moment because the max visible notification is one
            return this.notifications.shift();
        },

        clear() {
            this.notifications = [];

            return this;
        },
    },
});
